export enum TransactionTypes
{
	A = "Grant / Award",
	C = "Conversion",
	D = "In lieu of Dividend",
	E = "Exercise of options",
	F = "Payment of exercise price or tax liability",
	G = "Gift",
	H = "Expiration (or cancellation) of long derivative position",
	I = "Discretionary transaction",
	J = "Other",
	L = "Small acquisition under",
	M = "Exercise or conversion of derivative security",
	O = "Sale of Options",
	P = "Purchase",
	S = "Sale",
	T = "Transfer in",
	U = "Transfer out",
	W = "Will execution",
	X = "Exercise of in-the-money or at-the-money derivative security",
	Z = "Deposit into or withdrawal from voting trust"
}
export type TransactionTypeKeys = keyof typeof TransactionTypes;

/**
 * Large Number Abbreviations
 */
export enum LNA
{
	m = "Mil",
	b = "Bil",
	t = "Tril"
};

export interface ResponseError
{
	message: string
	extensions: {
		code: string
	}
};